import { importSourcesApi } from '../api/importSourcesApi';

/** Extract import document id from resolved download URL or import-document:// scheme. */
export function parseImportDocumentId(href: string | null | undefined): number | null {
  if (!href) return null;
  const scheme = href.match(/^import-document:\/\/(\d+)/i);
  if (scheme) return Number(scheme[1]);
  const path = href.match(/\/import\/documents\/(\d+)\/(?:download|view)/i);
  if (path) return Number(path[1]);
  return null;
}

export function isImportDocumentLink(href: string | null | undefined): boolean {
  return parseImportDocumentId(href) != null;
}

export type ImportDocumentNavigate = (path: string) => void;

/**
 * Open imported document in HAWK's unified preview page (same tab).
 * Excel URL-list imports use normal http(s) article links after crawl.
 */
export async function openImportDocument(
  hrefOrId: string | number,
  navigate?: ImportDocumentNavigate,
): Promise<void> {
  const docId =
    typeof hrefOrId === 'number' ? hrefOrId : parseImportDocumentId(hrefOrId);
  if (docId == null) {
    throw new Error('Not an import document link');
  }

  await importSourcesApi.getDocument(docId);
  const path = `/document-preview/${docId}`;
  if (typeof navigate === 'function') {
    navigate(path);
  } else {
    window.location.assign(path);
  }
}

/** @deprecated use openImportDocument */
export async function downloadImportDocument(hrefOrId: string | number): Promise<void> {
  return openImportDocument(hrefOrId);
}
